import { __extends } from "tslib";
import { TextureBaseWebGL } from './TextureBaseWebGL';
import { UnloadService } from '../managers/UnloadManager';
import { Settings } from '../Settings';
var TextureWebGL = /** @class */ (function (_super) {
    __extends(TextureWebGL, _super);
    function TextureWebGL(context, width, height) {
        var _this = _super.call(this, context) || this;
        _this.textureType = 'texture2d';
        /*internal*/ _this._frameBuffer = [];
        /*internal*/ _this._frameBufferDraw = [];
        /*internal*/ _this._renderBuffer = [];
        /*internal*/ _this._renderBufferDepth = [];
        /*internal*/ _this._mipmapSelector = 0;
        /*internal*/ _this._multisampled = false;
        /*internal*/ _this._isFilled = false;
        /*internal*/ _this._isPMA = false;
        /*internal*/ _this._isRT = false;
        /*internal*/ _this._skipPresent = false;
        //keepAliveTime: number = 30_000;
        _this.lastUsedTime = 0;
        if (!width || !height) {
            throw new Error("Incorrected size of texture { width: " + width + ", height: " + height + "}");
        }
        _this._width = width;
        _this._height = height;
        _this._glTexture = _this._gl.createTexture();
        return _this;
    }
    TextureWebGL.store = function (tex) {
        var key = tex._width << 16 | tex._height;
        var array = TextureWebGL._pool[key] || (TextureWebGL._pool[key] = []);
        if (array.indexOf(tex) > -1) {
            tex.lastUsedTime = this.unloadManager.correctedTime;
            return true;
        }
        if (array.length >= this.SIZE_POOL_LIMIT) {
            return false;
        }
        array.push(tex);
        if (Settings.ENABLE_UNLOAD_TEXTURE) {
            tex.lastUsedTime = this.unloadManager.correctedTime;
            this.unloadManager.addTask(tex);
            // const count = this.unloadManager.execute();
            // count && console.debug('[TextureWebGL Experimental] Remove textures persistently', count);
        }
        return true;
    };
    TextureWebGL.remove = function (tex) {
        var key = tex._width << 16 | tex._height;
        var array = TextureWebGL._pool[key];
        if (!array || !array.length)
            return false;
        var index = array.indexOf(tex);
        return index > -1 && !!array.splice(index, 1);
    };
    TextureWebGL.create = function (context, width, height) {
        // const count = this.unloadManager.execute();
        // count && console.debug('[TextureWebGL Experimental] Remove textures persistently', count);
        var _a;
        var key = width << 16 | (height | 0);
        var tex = (_a = TextureWebGL._pool[key]) === null || _a === void 0 ? void 0 : _a.pop();
        if (tex) {
            this.unloadManager.removeTask(tex);
            return tex;
        }
        return new TextureWebGL(context, width, height);
    };
    Object.defineProperty(TextureWebGL.prototype, "canUnload", {
        get: function () {
            return this._glTexture && !this._isRT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextureWebGL.prototype, "isPOT", {
        get: function () {
            return !(this._width & (this._width - 1)) && !(this._height & (this._height - 1));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextureWebGL.prototype, "width", {
        get: function () {
            return this._width;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextureWebGL.prototype, "height", {
        get: function () {
            return this._height;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextureWebGL.prototype, "multisampled", {
        get: function () {
            return this._multisampled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextureWebGL.prototype, "framebuffer", {
        get: function () {
            return this._frameBuffer[this._mipmapSelector];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextureWebGL.prototype, "textureFramebuffer", {
        get: function () {
            return this.multisampled
                ? this._frameBufferDraw[this._mipmapSelector]
                : this._frameBuffer[this._mipmapSelector];
        },
        enumerable: false,
        configurable: true
    });
    TextureWebGL.prototype.setFrameBuffer = function (enableDepthAndStencil, antiAlias, surfaceSelector, mipmapSelector) {
        if (enableDepthAndStencil === void 0) { enableDepthAndStencil = false; }
        if (antiAlias === void 0) { antiAlias = 0; }
        if (surfaceSelector === void 0) { surfaceSelector = 0; }
        if (mipmapSelector === void 0) { mipmapSelector = 0; }
        this._context._texContext.setFrameBuffer(this, enableDepthAndStencil, antiAlias, surfaceSelector, mipmapSelector);
    };
    TextureWebGL.prototype.presentFrameBuffer = function () {
        // deprecation
        console.warn('[Texture] Framebuffer present internal method of ContextWebGL');
    };
    /**
     * @inheritdoc
     */
    TextureWebGL.prototype.dispose = function () {
        if (!this.multisampled
            && Settings.ENABLE_TEXTURE_POOLING
            && TextureWebGL.store(this))
            return;
        this.unload();
    };
    TextureWebGL.prototype.unload = function () {
        TextureWebGL.remove(this);
        this._context._texContext.disposeTexture(this);
        this._glTexture = null;
        this._renderBuffer = null;
        this._renderBufferDepth = null;
        this._frameBuffer = null;
        this._frameBufferDraw = null;
        this._mipmapSelector = 0;
        this._width = this._height = 0;
        this._multisampled = false;
        this._state.dispose();
    };
    /* eslint-disable-next-line */
    TextureWebGL.prototype.uploadFromArray = function (array, miplevel, premultiplied) {
        if (miplevel === void 0) { miplevel = 0; }
        if (premultiplied === void 0) { premultiplied = false; }
        this._context._texContext.uploadFromArray(this, array, miplevel, premultiplied);
        this._isFilled = true;
        this._isPMA = premultiplied;
    };
    TextureWebGL.prototype.uploadFromURL = function (urlRequest, miplevel, premultiplied) {
        if (miplevel === void 0) { miplevel = 0; }
        if (premultiplied === void 0) { premultiplied = false; }
        //dummy code for testing
        this._context._texContext.uploadFromArray(this, null, miplevel, premultiplied);
        this._isFilled = true;
        this._isPMA = premultiplied;
    };
    TextureWebGL.prototype.uploadCompressedTextureFromArray = function (array, offset, async) {
        if (async === void 0) { async = false; }
    };
    TextureWebGL.prototype.generateMipmaps = function () {
        this._gl.bindTexture(this._gl.TEXTURE_2D, this._glTexture);
        this._gl.generateMipmap(this._gl.TEXTURE_2D);
        //this._gl.bindTexture( this._gl.TEXTURE_2D, null );
    };
    TextureWebGL.SIZE_POOL_LIMIT = 10;
    TextureWebGL.unloadManager = UnloadService.createManager({
        keepAliveTime: 20000,
        name: 'TextureWebGL',
        priority: 1000,
    });
    TextureWebGL._pool = {};
    return TextureWebGL;
}(TextureBaseWebGL));
export { TextureWebGL };
